// extracted by mini-css-extract-plugin
export default {"tupacGrid":"bn-z","tupacHeader":"cn-z","tupacHeader2":"dn-z","tupacMenu":"en-z","tupacMenu2":"fn-z","tupacMain":"gn-z","tupacMain2":"hn-z"};